import ApiService from '@/services/core/api.service'

const ReportService = {
  async getApprovalHistories (query) {
    return ApiService.get(`rad/reports/approval-histories?${query}`)
  }
}

export default ReportService
